import { useMemo } from 'react';

import { CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import DashboardView from '../components/dashboard/DashboardView';
import { DashboardProvider } from '../context/DashboardContext';

const Dashboard = () => {
    const { ready } = useTranslation();
    const { classUuid } = useParams<{ classUuid: string }>();

    const urlParams = useMemo(() => {
        const search = new URLSearchParams(window.location.search);
        return {
            sessionId: search.get('session_id'),
            isDemo: search.get('isDemo')
        };
    }, []);

    const renderDashboard = () => (
        <DashboardProvider sessionUuid={urlParams.sessionId} classUuid={classUuid} isDemo={urlParams.isDemo}>
            <DashboardView />
        </DashboardProvider>
    );

    return ready ? renderDashboard() : <CircularProgress />;
};

export default Dashboard;
